






























































import Vue from "vue";
import Component from 'vue-class-component';
import StarIcon from 'vue-material-design-icons/Star.vue';

@Component({
    components: { StarIcon },
})
export default class DetalhesAssistencia extends Vue {
    public image = require("@/assets/images/newcrash.svg");
    public readonly assistencias = [
        { key: "sem",      label: 'Não',      value: 0,     agregado: 0,    index: 0 },
        { key: "prata",    label: 'Prata',    value: 65.9,  agregado: 28.9, index: 1 },
        { key: "ouro",     label: 'Ouro',     value: 73.9,  agregado: 50.9, index: 2 },
        { key: "diamante", label: 'Diamante', value: 120.9, agregado: 33.9, index: 3 },
    ];
    public item = {
        tags: ["Registro de CNVR", "Retorno ao domicílio", "Translado de corpos", "Transmissão de Mensagens", "Reboque 300km", "Socorro Elétrica", "Pane Mecânica", "Chaveiro", "Envio de acompanhante", "Remoção inter hospitalar"],
        text: "Em caso de pane elétrica ou mecãnica no seu veículo, você pode acionar até 1 assistência por mês, e em caso de acidente 0 km é ilimitado",
    };

    get cobertura () {
        return this.$store.state.cotacao.valor_assistencia;
    }

    set cobertura (value) {
        const data = this.assistencias.find( (item) => item.value === value );
        if ( data !== undefined ) {
            this.$store.commit('SET_ASSISTENCIA', data);
        }
    }
}
